import type { ComponentType } from 'react';
import { FaDiscord, FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok, FaXTwitter, FaYoutube } from 'react-icons/fa6';

export interface FooterSocial {
  name: string;
  href: string;
  Icon: ComponentType<{ size?: number; 'aria-hidden'?: boolean }>;
  color: string;
}

export const FOOTER_NOPING_HREFS = ['/servers', '/games', '/pricing', '/download', '/trial', '/work-with-us', '/beta-tester', '/aboutus'];
export const FOOTER_TECH_HREFS = ['/features/multi-connection', '/features/multi-internet', '/features/boost-fps', '/features/ping-reduction', '/features/packet-loss', '/features/disconnect-correction', '/features/ping-spikes-correction', '/features/automatic-game', '/features/comprehensive-statistics', '/features/connection-monitoring', '/features/manual-server', '/features/ip-block', '/features/dns-optimization', '/features/audiopad', '/features/aim-trainer', '/pro-settings'];
export const FOOTER_HELP_HREFS = ['/tutorial/windows', '/tutorial/ios', '/tutorial/android', '/support', '/terms/privacy-policy', '/terms/terms-of-use', '/affiliates'];
export const FOOTER_BLOG_HREFS = ['/guia-reduzir-lag', '/jitter', '/jogos-competitivos', '/melhorar-ping', '/reduzir-packet-loss'];
export const FOOTER_GUIDE_HREFS = ['/technology', '/features/boost-fps', '/exitlag', '/lagofast', '/wtfast', '/gearup', '/mudfish'];
export const FOOTER_FEEDBACK_HREFS = ['/evaluate-our-platform', '/feature-suggestion'];

export const FOOTER_SOCIALS: FooterSocial[] = [
  { name: 'TikTok', href: 'https://www.tiktok.com/@nopingbr', Icon: FaTiktok, color: '#25F4EE' },
  { name: 'Instagram', href: 'https://www.instagram.com/nopingbr/', Icon: FaInstagram, color: '#E4405F' },
  { name: 'X', href: 'https://x.com/NoPingBR', Icon: FaXTwitter, color: '#FFFFFF' },
  { name: 'YouTube', href: 'https://www.youtube.com/@noping', Icon: FaYoutube, color: '#FF0000' },
  { name: 'Discord', href: 'https://discord.gg/noping', Icon: FaDiscord, color: '#5865F2' },
  { name: 'Facebook', href: 'https://www.facebook.com/NoPingbr', Icon: FaFacebookF, color: '#1877F2' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/noping/', Icon: FaLinkedinIn, color: '#0A66C2' },
];
